// extracted by mini-css-extract-plugin
export default {"step-value":"steps-module__step-value--TpG","stepValue":"steps-module__step-value--TpG"};